import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/resellers';

export default {
	/**
	 * Fetch All Reseller
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} params.date_since Date Since
	 * @param {string} params.date_until Date Until
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getResellers(params, cb, errorCb) {
		const url = endpoint;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch Summary
	 *
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getSummary(params, cb, errorCb) {
		const url = `${endpoint}/summary`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch Contact Detail
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch Contact Detail
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	showBySourceId(id, cb, errorCb) {
		const url = `${endpoint}/source/${id}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create Expenses
	 *
	 * @param {Object} params
	 * @param {'manual'} params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.amount Amount
	 * @param {string} params.date Date
	 * @param {string} params.product_id Product ID
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	store(params, cb, errorCb) {
		const url = `${endpoint}`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete Expenses
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Reseller
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of Expense ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDelete(ids = [], cb, errorCb, permanent = false) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			resellers: idsJSON,
		};
		if (permanent) {
			params.permanent = true;
		}

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Bulk Update Tiers
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of Expense ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkUpdateTier(params, cb, errorCb) {
		const url = `${endpoint}/bulk-tier`;

		const idsJSON = JSON.stringify(params.ids);
		const data = {
			tier_id: params.tier_id,
			resellers: idsJSON,
		};

		client
			.put(url, data)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},
	/**
	 * Update status active
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	updateStatusActive(id, cb, errorCb) {
		const url = `${endpoint}/${id}/active`;

		client
			.put(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Update status pending
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	updateStatusPending(id, cb, errorCb) {
		const url = `${endpoint}/${id}/active`;

		client
			.put(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Export Expenses
	 *
	 * @param {Object} params
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	export(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Single Update Expenses
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {'manual' | 'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.amount Amount
	 * @param {string} params.date Date
	 * @param {string} params.product_id Product ID
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Update Tier
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {'manual' | 'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.amount Amount
	 * @param {string} params.date Date
	 * @param {string} params.product_id Product ID
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	updateTier(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/tier`;
		client
			.patch(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Update Expenses
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of expenses ID
	 * @param {Object} params.expense_data Expense Data
	 * @param {string} params.expense_data.name  Expense Data Name
	 * @param {string} params.expense_data.product  Expense Data Product ID
	 * @param {string} params.expense_data.amount  Expense Data Amount
	 * @param {string[]} params.expense_data.tags  Expense Data Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	updateBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/* ===== EXPENSE SOURCE ===== */
	/**
	 * Fetch All Expenses Source
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.product_id] Product ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getExpenseSource(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/source?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create Expenses
	 *
	 * @param {Object} params
	 * @param {Object} params.data Data
	 * @param {'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {string} params.product_id Product ID
	 * @param {string} params.data.ad_account_name Ad Account Name
	 * @param {string} params.data.ad_account_id Ad Account ID
	 * @param {string} params.data.campaign_id Campaign ID
	 * @param {string} params.data.campaign_name Campaign Name
	 * @param {string[]} params.tags Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	// storeSource(params, cb, errorCb) {
	// 	const url = `${endpoint}/source`;
	// 	client
	// 		.post(url, params)
	// 		.then((response) => {
	// 			if (cb) cb(response.data);
	// 		})
	// 		.catch((e) => {
	// 			if (errorCb) errorCb(e);
	// 		});
	// },

	/**
	 * Single Update Expenses
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {'automatic' } params.type Type
	 * @param {string} params.name Name
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	updateSource(id, params, cb, errorCb) {
		const url = `${endpoint}/source/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Expenses Source
	 *
	 * @param {Object} params
	 * @param {string[]} params.expense_ids Array of Expense ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDeleteSource(ids = [], cb, errorCb) {
		const url = `${endpoint}/source`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			expense_source_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},
};
